import QuizListUser from "../../components/quiz/QuizListUser";

export default function QuizListUserPage(){
     return(
          <div>
               <QuizListUser />
          </div>
     )
}